import React from 'react';
import { animated } from 'react-spring';

import type { ButtonProps } from 'src/shared/components/Button';
import { Button } from 'src/shared/components/Button';
import { useSingleSignOn, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Page, loginStarted } from 'src/shared/telemetry';
import { useSlide } from 'src/shared/transitions';

// TODO(@hover/blueprint@1.0): remove this omit after 1.0 when this is removed,
// for now this prevents additional deprecated usage of `loading` vs `isLoading`
export interface LoginButtonProps extends Omit<ButtonProps, 'loading'> {}

const LoginButton = ({ isLoading }: LoginButtonProps) => {
  const t = useTranslate(TranslationNamespace.LOGIN);

  const { isActive: isSingleSignOnActive, isLoading: isSingleSignOnLoading } =
    useSingleSignOn();

  const transitions = useSlide(isSingleSignOnActive);

  const isProcessingRequest = isSingleSignOnActive
    ? isSingleSignOnLoading || isLoading
    : isLoading;

  return (
    <Button
      alignSelf="stretch"
      isLoading={isProcessingRequest}
      label={
        isSingleSignOnActive
          ? t('singleSignOn.logInWithSingleSignOn')
          : t('logIn')
      }
      marginTop={500}
      pageName={Page.LOGIN__INPUT}
      primaryCallToAction
      size="large"
      testId="login-button"
      track={loginStarted}
      type="submit"
    >
      {transitions.map(({ item, key, props: style }) =>
        item ? (
          <animated.div key={key} style={style}>
            {t('singleSignOn.logInWithSingleSignOn')}
          </animated.div>
        ) : (
          <animated.div key={key} style={style}>
            {t('logIn')}
          </animated.div>
        ),
      )}
    </Button>
  );
};

export { LoginButton };
